import { useCallback, useEffect, useState } from "react";
import { foCaAnTruongApi } from "../api/foCaAnTruongApi";
import { IFoCaAnTruongVm } from "../models/response/thuc-don/IFoCaAnTruong";

export const useCaAnByTruong = () => {
  const [caAnList, setCaAnList] = useState<IFoCaAnTruongVm[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const loadCaAnByTruong = useCallback(async (dm_truong_id: number) => {
    if (!dm_truong_id) {
      setCaAnList([]);
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      const response = await foCaAnTruongApi.select_by_truong(dm_truong_id);
      
      if (response.is_success) {
        setCaAnList(response.data || []);
      } else {
        setError(response.message || "Có lỗi xảy ra khi tải danh sách ca ăn");
        setCaAnList([]);
      }
    } catch (err) {
      setError("Có lỗi xảy ra khi tải danh sách ca ăn");
      setCaAnList([]);
      console.error("Error loading ca an by truong:", err);
    } finally {
      setIsLoading(false);
    }
  }, []);

  const clearCaAnList = useCallback(() => {
    setCaAnList([]);
    setError(null);
  }, []);

  return {
    caAnList,
    isLoading,
    error,
    loadCaAnByTruong,
    clearCaAnList,
  };
};
